// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("C:\\Donatello\\work\\1b39dd3690dc639\\src\\pages\\404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("C:\\Donatello\\work\\1b39dd3690dc639\\src\\pages\\index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

